import { render, staticRenderFns } from "./BuyItem.vue?vue&type=template&id=1772f13b"
import script from "./BuyItem.vue?vue&type=script&lang=js"
export * from "./BuyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports